<template>
  <button
    v-if="recipeId"
    @click="performToggleLike"
    class="btn btn-like"
    :disabled="internalLikeInProgress"
    title="Нравится"
  >
    <i
      :class="internalIsLiked ? 'bi bi-heart-fill text-danger' : 'bi bi-heart'"
    ></i>
  </button>
</template>

<script>
export default {
  name: "RecipeLike",
  props: {
    recipeId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      internalIsLiked: false,
      internalLikeInProgress: false,
    };
  },
  watch: {
    recipeId: {
      immediate: true,
      async handler(newId, oldId) {
        if (newId && newId !== oldId) {
          await this.checkLikeStatus();
        } else if (!newId) {
          this.internalIsLiked = false;
        }
      },
    },
    // Watch for API URL availability to re-check like status if it wasn't available initially
    "$globalState.apiUrl"(newApiUrl, oldApiUrl) {
      if (newApiUrl && !oldApiUrl && this.recipeId) {
        this.checkLikeStatus();
      }
    },
  },

  methods: {
    async performToggleLike() {
      if (!this.recipeId || this.internalLikeInProgress) return;
      if (!this.$globalState.apiUrl) {
        console.error("RecipeLike: API URL not available, cannot toggle like.");
        return;
      }

      this.internalLikeInProgress = true;
      const command = this.internalIsLiked
        ? `user.like.remove/${this.recipeId}`
        : `user.like.add/${this.recipeId}`;
      try {
        await this.sendCmd(command);
        this.internalIsLiked = !this.internalIsLiked;
        this.$emit("like-toggled", this.internalIsLiked, this.recipeId);
      } catch (error) {
        console.error("RecipeLike: Error toggling like:", error);
        this.$emit("like-error", error);
      } finally {
        this.internalLikeInProgress = false;
      }
    },
    async checkLikeStatus() {
      if (!this.recipeId) {
        this.internalIsLiked = false;
        return;
      }
      if (!this.$globalState.apiUrl) {
        console.warn(
          "RecipeLike: API URL not available, cannot check like status for recipeId:",
          this.recipeId
        );
        // Do not set to false here, wait for API URL or rely on default false
        return;
      }

      // No need for internalLikeInProgress during check, it's a read operation
      try {
        const command = `user.recipe.isLiked/${this.recipeId}`;
        const response = await this.sendCmd(command);
        if (typeof response === "string") {
          this.internalIsLiked = JSON.parse(response).is_liked;
        } else if (
          typeof response === "object" &&
          response !== null &&
          typeof response.is_liked === "boolean"
        ) {
          this.internalIsLiked = response.is_liked;
        } else {
          this.internalIsLiked = false; // Default on unexpected format
        }
      } catch (error) {
        this.internalIsLiked = false; // Default to not liked on error
      }
    },
  },
};
</script>

<style scoped>
.btn-like {
  background: none;
  border: none;
  margin-bottom: 8px;
  font-size: 1.5rem;
  padding: 0;
}
</style>
